// extracted by mini-css-extract-plugin
export default {"modal":"CustomModal_modal__xSKDe","subheader":"CustomModal_subheader__4p+AU","divider":"CustomModal_divider__Vc8iX"};